<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="page_header_wrap" :class="{ filters_open: filtersList }">
        <div class="page_header" style="    padding-bottom: 60px;">
          <div>
          
            <div class="analytic_details" v-if="selectedUser" >
              <figure>
              <img :src="selectedUser['details']['photo']" @error="setAltImg($event)"></figure>
              <div>
                <h2>{{selectedUser['details']['name']}}</h2>
                <a>{{selectedUser['details']['email']}}</a>
                <p><span>Company</span>{{selectedUser['companyDetails']['name']}}</p>  
                <!-- <p><span>Customer</span>Yopmail Inc</p>                  -->
              </div>
            </div>
          </div>
          <div class="page_actions">             
            <button v-if="selectedTab=='sdk'"  class="secondary_btn filters_btn" :class="{ active: filtersList }" @click="filtersList = !filtersList">
              <span class="material-icons"> filter_list</span>Filters
            </button>
          </div>
        </div> 
        <div class="filter_layer" @click="filtersList = !filtersList"></div>
             <div
      ref="filterCard" 
      class="user-list-filters filters_list"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
       <template v-if="selectedTab=='sdk'" >
         <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  >
        
          <label class="text-sm opacity-75">Versions</label>
      
          <multiselect
            v-model="filterData.versionIds"
            :options="versions" 
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            placeholder="Select"
            label="name"
            track-by="name"
            :preselect-first="false"
            id="Versions"
            :multiple="true"
           
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span
                class="multiselect__selectcustom"
                v-if="values.length && !isOpen"
                >{{ values.length }} Version(s) selected</span
              >
              <span
                class="multiselect__selectcustom"
                v-if="values.length && isOpen"
              ></span>
            </template>
            <span slot="noResult">No Versions Found</span>
          </multiselect>
           
        </div>
        <!--<div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"   >
        <label class="text-sm opacity-75">Search</label>
          <input
           v-model="serch_title"
            class="search_field"
            type="text"
            @keyup.enter="onEnter"
            placeholder="Search By Name/Version"
          />
        </div>-->
        
       </template>
       
        

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" v-if="selectedTab=='sdk'">
          <label class="text-sm opacity-75">{{selectedTab=='sdk'?'Downloaded  On':'Agreed On'}}</label>
          <date-range-picker :autoApply="autoApply" :maxDate="maxDate"
          :ranges="false" v-model="selected_createdDateRange" placeholder="Select Range" opens="'right'"></date-range-picker>
        </div>

        <div v-if="selectedTab=='sdk'" class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"   ></div>

         <template v-if="selectedTab!='sdk'">
       <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"   ></div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10"  ></div>
       <div class="vx-col md:w-1/4 sm:w-1/2 w-full marb10" ></div>
       </template>

        
        
       

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full d-flex align-end justify-end marb10" v-if="selectedTab=='sdk'">
        <button @click="clearFilters()" class="secondary_btn">
            Clear 
          </button>
          <button class="primary_btn marl15" @click="applYfilter() , filtersList = !filtersList">
            Apply
          </button>
        </div>
        
      </div>
    </div>
      
    </div>

    <div class="User_analytics_tabs">
      <vs-tabs>
                <vs-tab label="SDK Analytics" @click="tabChanged('sdk')">
                    <template>
                      <vs-table :data="sdkList" noDataText="">
                        <template slot="thead">
                        <!----"path": "name",//createdOn,createdByName,updatedOn,version-->
                          <vs-th> SDK</vs-th>
                            <vs-th> 
                                <a  @click="sortMe('version')" v-bind:class="{
                                    sort_ascending: sortKeys['version'] == 1,
                                    sort_descending: sortKeys['version'] != 1,
                                  }"
                                  > Version</a>
                              
                          </vs-th>
                          <!--<vs-th > 
                            <a  @click="sortMe('companyName')" v-bind:class="{
                                    sort_ascending: sortKeys['companyName'] == 1,
                                    sort_descending: sortKeys['companyName'] != 1,
                                  }"
                                  >Customer</a>
                          
                          </vs-th>
                            
                          
                          <vs-th>
                          <a  @click="sortMe('createdByName')" v-bind:class="{
                                    sort_ascending: sortKeys['createdByName'] == 1,
                                    sort_descending: sortKeys['createdByName'] != 1,
                                  }"
                                  >
                            User
                            </a>
                          </vs-th>-->
                          <vs-th> 
                          <a  @click="sortMe('createdOn')" v-bind:class="{
                                    sort_ascending: sortKeys['createdOn'] == 1,
                                    sort_descending: sortKeys['createdOn'] != 1,
                                  }"
                                  >
                            Downloaded  On</a>
                          </vs-th>    
                        </template>
                        <template v-if="sdkList && sdkList.length > 0">
                        
                            <vs-tr v-for="(sdk ,index) in sdkList" :key="index">
                              <vs-td class="sdk_details_td sdk_list">
                                <p> {{sdk['sdkDetails']['title']}} </p>
                                
                              </vs-td>
                              <vs-td>{{sdk['sdkDetails']['version']}}</vs-td>
                            <!--<vs-td> {{sdk['companyDetails']['name']}}</vs-td>

                              <vs-td> {{sdk['userName']}}
                                  <template>
                                      <br>
                                      <small>{{ sdk.userEmail }}</small> 
                                  </template>
                              </vs-td>-->
                              <vs-td> {{sdk.createdOn | formatDate }}
                                <br>
                                <small>{{ sdk.createdOn | formatTime}}</small>   
                              </vs-td>
                            
                            </vs-tr>       
                          <!-- </template> -->
                        </template>
                          <template v-else>
                            <tr>
                              <td class="center-align" colspan="7">No Downloads  Found!</td>
                            </tr>
                          </template>
                      </vs-table>
                      <div class="pagination_wrap" v-if="totalpages > 0">
                        <div class="pagination_content" >
                          <h6>Show Records</h6>
                          <multiselect
                            :multiple="false" 
                              @input="change_perPage()"
                            placeholder="Page"
                            
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :preserve-search="true"
                            
                            v-model="perPage" :options="perPeges" >
                              <template slot="selection" slot-scope="{ values, isOpen }">
                                <span
                                  class="multiselect__selectcustom"
                                  v-if="values.length && !isOpen"
                                  >{{ values.length }} selected</span
                                >
                                <span
                                  class="multiselect__selectcustom"
                                  v-if="values.length && isOpen"
                                ></span>
                              </template>
                              
                            </multiselect>
                        </div>
                        <vs-pagination
                          :total="totalpages"
                          :max="7"
                          v-model="page"
                          @input="getSdkList()"
                        />
                      </div>
                    </template>
                </vs-tab>
                <vs-tab label="Agreement Analytics" @click="tabChanged('aggrement')">
                    <template>
                   
                      <vs-table :data="agList" noDataText="">
                        <template slot="thead">
                       
                          <vs-th> License</vs-th>
                           
                           <vs-th> License Created On</vs-th>  
                          <vs-th> 
                          <a  @click="userAggrementListSortMe('createdOn')" v-bind:class="{
                                    sort_ascending: sortKeys['createdOn'] == 1,
                                    sort_descending: sortKeys['createdOn'] != 1,
                                  }"
                                  >
                            Agreed On</a>
                          </vs-th> 
                          
                         
                        </template>
                        <template v-if="agList && agList.length > 0">
                        
                            <vs-tr v-for="(sdk ,index) in agList" :key="index">
                              <vs-td class="sdk_details_td sdk_list">
                                <p> {{sdk['licenseDetails']['title']}} </p>
                                
                                
                              </vs-td>

                               <vs-td> {{sdk['licenseDetails'].createdOn | formatDate }}
                                <br>
                                <small>{{ sdk['licenseDetails'].createdOn | formatTime}}</small>   
                              </vs-td>

                               <vs-td> {{sdk.createdOn | formatDate }}
                                <br>
                                <small>{{ sdk.createdOn | formatTime}}</small>   
                              </vs-td>

                              
                            
                            </vs-tr>       
                         
                        </template>
                          <template v-else>
                            <tr>
                              <td class="center-align" colspan="7">No Data Found!</td>
                            </tr>
                          </template>
                      </vs-table>
                      <div class="pagination_wrap" v-if="agTotalpages > 0">
                        <div class="pagination_content" >
                          <h6>Show Records</h6>
                          <multiselect
                            :multiple="false" 
                              @input="change_perPage(true)"
                            placeholder="Page"
                            
                            :close-on-select="true"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :preserve-search="true"
                            
                            v-model="perPage" :options="perPeges" >
                              <template slot="selection" slot-scope="{ values, isOpen }">
                                <span
                                  class="multiselect__selectcustom"
                                  v-if="values.length && !isOpen"
                                  >{{ values.length }} selected</span
                                >
                                <span
                                  class="multiselect__selectcustom"
                                  v-if="values.length && isOpen"
                                ></span>
                              </template>
                              
                            </multiselect>
                        </div>
                        <vs-pagination
                          :total="agTotalpages"
                          :max="7"
                          v-model="agPage"
                          @input="userAggrementList()"
                        />
                      </div>
                    </template>
                </vs-tab>
      </vs-tabs>

    </div>


    

    
    
  </div>
</template>

<script>
import axios from '../../../axios.js' 

import vSelect from 'vue-select'
import FileUpload from "vue-upload-component/src";
import Multiselect from "vue-multiselect-inv";
import _ from "lodash";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import defaultProfile from "@/assets/images/pages/user-icon.png"
export default {
  components: {
    vSelect,
    FileUpload,
    Multiselect,
    DateRangePicker
  },
 computed: {
    validateForm () {
      return this.errors.any() || this.newSdk.sdk ==null || this.newSdk.document ==null || (this.newSdk.title =='' || this.newSdk.title ==null) || (this.newSdk.description =='' || this.newSdk.description ==null) || (this.newSdk.version =='' || this.newSdk.version ==null)
    },
    // validateCompanies() {
    //   return this.companyIds.length > 0
    // },
    // validateCus() {
    //   return this.cusIds.length > 0
    // },
    activeUserInfo () {
      return this.$store.state.auth.user
    }
  },
  data: () => ({
      selectedTab:"sdk",
      selected_createdDateRange :{
      startDate: null,
      endDate: null
    },
     autoApply: "",
     maxDate: new Date(),
      searchCustomer:'',
      customerList:[],
      filterData: {
      title: "",
      statusIds: [],
      productIds: [],
      productIds: [],
      projectIds: [],
      customerIds: [],
      createdOnRange: [],
      companyIds:[],
      
      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      versionIds:[]

    },
    filtersList: false,
    callFromSort:false,
    radios1: 'EveryOne',
    // Filter Options
    apiURL:null,
    popupTitle:'Add SDK Release',
    isAdd:true,
    documents:[],
    companyIds: [],
    cusIds: [],
    textarea: '',
    popupcreateticket: false,
    pubContent: '',
    selected: '',
    searchQuery: '',
       docPrivew:false,
     docValue:'',
     docType:"",
     selectedFile:null,
     companies: [],
     sdkUsers: [],

    ////////////
    serch_title: "",
    sortKey: {},
    sortKeys: {  "name":'1',createdOn:-1,createdByName:1,updatedOn:1,version:1 ,companyName:1 },
    sdkList: [],
    perPeges: [25, 50, 75, 100],

    page: 1,
    perPage: 25,
    totalpages: 0,
    newSdk:{
      "description":"",
      "title": "",
      "version": "",
      "sdk": null,
      "document": null
    },
    publishPopup:false,
    sdkBucketList:[],

     agPage: 1,
     agPerPage: 25,
    agTotalpages: 0,
    agList:[],
    versions:[],
    selectedUser:null
  }),
  methods: {
      tabChanged(tab="sdk"){
          this.selectedTab =tab;
          this.clearFilters();
      },
      setAltImg(event) {
      console.log("IMAGE ERROR");
      event.target.src = defaultProfile;
      
  },
      // @search-change="searchCustomerList"
    searchCustomerList(val=''){
      this.searchCustomer = val;
      this.getCustomerList();
    },
    getCustomerList() {
        //filterData.companyIds
      let postData = {"filters":
      {"title":this.searchCustomer,"roleIds":[2],
      "statusIds":[],
      "createdOnRange":[],
      "companyIds":[],
      },"sorting":{"path":"createdOn","order":1},"page":1,"perpage":25};
     
     if(this.filterData.companyIds && this.filterData.companyIds.length>0){
         _.forEach(this.filterData.companyIds  ,(obj)=>{
             postData['filters']['companyIds'].push(obj['_id']);
         });
     }
      this.customerList = [];
      this.$store
        .dispatch("auth/get_users_list", postData)
        .then((response) => {
          //this.customerList = response.list;
          let dt  = response.list;
          if(dt.length>0){
            _.forEach(dt ,(obj)=>{
              let cus = obj;
              if(_.has(obj ,"companyDetails")){
                cus['name'] =  cus['name']+" ("+obj['companyDetails']['name']+")"
              }
              this.customerList.push(cus);



            });

          }
          //this.totalpages = Math.ceil(response.totalCount / this.perPage);
        })
        .catch((err) => {
          console.log(err);
          this.loaded = true;
        });
    },
    getsdkBucketList(){
       this.$store
        .dispatch("getsdkBucketList", {sdkBucket:true})
        .then((response) => {
         
          this.sdkBucketList = response;
         
        })
        .catch((err) => {
          console.log(err);
          
        });

    },
    trackClicks(type=""){
     let viewasCu =  localStorage.getItem('ViewAsCustomer');
      if(type !="" && this.activeUserInfo.roleId == 2 && (viewasCu==undefined || viewasCu ==null) )
        this.$store.dispatch("auth/trackClicks" ,{"type":type});
    },

    
    
    
    
    
    
    remove( type) {
       
      if(type =='sdk'){
        this.newSdk.sdk = null
      }else if(type =='document'){
        this.newSdk.document = null;
      }
      },
      upload(model ,type=''){

      if(type =='sdk'){
      this.newSdk.sdk =null;
      }else if(type =='document'){
      this.newSdk.document =null;
      }

          let temp_count = 0;
          let formData = new FormData();
          this.disabled_btn = true;          
          let mapper = model.map(
              item =>
              (item = {
                  name: item.name,
                  file: item.file ? item.file : null,
                  path: item.url ? item.url : "",
                  extn: item.name.split('.').pop(),
                  mimetype: item.type ? item.type : item.mimetype,
                  
              })
          );
           var ext = mapper[0].extn.split('.').pop();
           if (['zip'].indexOf(ext.toLowerCase()) > -1) {
              this.$vs.loading();
              if (mapper.length > 0) {
              mapper.forEach((doc, index) => {
                  formData.append("files", doc.file);
                  formData.append("secureType", "private");
                  this.$store.dispatch("uploadS3File", formData).then(response => {
                      temp_count++;
                      response.data.result.forEach(urlGenerated => {

                          if(type =='sdk'){
                            this.newSdk.sdk = urlGenerated;
                            
                          }else if(type =='document'){
                            this.newSdk.document = urlGenerated;
                          }
                          if (temp_count >= mapper.length) {
                              this.disabled_btn = false;
                              this.$vs.loading.close();
                          }

                          doc.url = urlGenerated;
                          delete doc.file;
                          mapper[index] = doc;

                      });
                  });

              });
              model.splice(0, mapper.length, ...mapper);
          }
            } else {
              this.$vs.notify({
            title: "Error",
            text: 'The format of the file you chose to upload is not supported',
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
            }

          
           

          
      },
  
      change_perPage(getaggList =false) {
        if(getaggList){
             this.agPage = 1;
             this.userAggrementList();

        }else{
        this.page = 1;
        this.getSdkList();
      }
      },
      
      
    detailsView(item){
      
      const payload = {
        userId: item._id,
      };
      this.$vs.loading();
      this.$store
        .dispatch("getUserDetails", payload)
        .then((res) => {
          if (res.details) {
            this.selectedUser = res
             
          }
         this.$vs.loading.close();
         
         
           
        })
        .catch((error) => {
          this.$vs.loading.close();
         
        });

    },     
    getSdkList(){
       const postData = {
        filters: {"title":this.serch_title ,
          "sdkIds": [],
        	"userIds": [],
         	"companyIds": [],
		      "createdOnRange": []
        },
        sorting: this.sortKey, //{"path": "name","order": -1	},
        
        page: this.page,
        perpage: this.perPage,
      };

    if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
    postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
    postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
    }

    if ( this.$route.params.id != undefined && this.$route.params.id != null ) {
         postData.filters['userIds'].push(this.$route.params.id);
         this.detailsView({"_id":this.$route.params.id});
    }
      
      /*
       if(this.filterData.companyIds && this.filterData.companyIds.length>0){
            _.forEach(this.filterData.companyIds  ,(obj)=>{
                postData['filters']['companyIds'].push(obj['_id']);
            });
        }
        */
        if(this.filterData.versionIds && this.filterData.versionIds.length>0){
                _.forEach(this.filterData.versionIds  ,(obj)=>{
                    postData['filters']['sdkIds'].push(obj['_id']);
                });
            }
     
      if(!this.callFromSort){
            this.sdkList = [];
      }
      this.callFromSort = false;
     
       this.$vs.loading()
      this.$store
        .dispatch("getSdkAnalytics", postData)
        .then((response) => {
          this.sdkList = response.list;
          
          this.totalpages = Math.ceil(response.totalCount / this.perPage);
           this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.loading.close();
          
        });

    },
    sortMe(sort_key = "" ,) {
      this.sortKey = { path: "createdOn", order: -1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        this.getSdkList();
      }
    },
    applYfilter(){
      if( this.selectedTab =="sdk"){
        this.getSdkList();
     }else{

       this.userAggrementList();
     }

    },
   
    clearFilters() {
      this.filtersList  =false;
      this.serch_title = '';
      this.filterData = {
      title: "",
      statusIds: [],
      productIds: [],
      productIds: [],
      projectIds: [],
      customerIds: [],
      createdOnRange: [],
      companyIds:[],
      
      priorityDetails: [],
      typeDetails: [],
      areaDetails: [],
      deviceFamDetails: [],
      versionDetails: [],
      versionIds:[],

    }
    this.selected_createdDateRange = {startDate:null ,endDate:null}
     if( this.selectedTab =="sdk"){
       // this.getSdkList();
        this.getSdkList();
     }else{

       this.userAggrementList();
     }
     
    },
   
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: 'All',
        value: 'all'
      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    
    downloadFile(value) {
      if(_.has(value , "path")){
        value['url'] = value['path'];
      }
      this.selectedFile = value;
      this.docValue ='';
      this.docPrivew =false;
      this.docType =false;
      this.docType = this.findmsDoctype(value['extn']);
    if(this.docType=="office" || this.docType == "image" || this.docType == "pdf" ){
      value.url = value.url.replace(  "https://deepvisioninv.s3.ap-south-1.amazonaws.com/",  ""  );
      let postdata = { keyName: value.url };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
        this.docValue =  response.data.result.data;
        if(this.docType=="office" ){
          this.docValue =  encodeURIComponent(response.data.result.data);
        }
      
      this.docPrivew =true;
      
      //window.open(response.data.result.data, "_blank");
    });

    }else{
      this.download_file(value );
    }
    
    // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
    

    
  },
  download_file(value ,sdkBucket=false) {
       
        if(_.has(value , "path")){
          value['url'] = value['path'];
        }
        if(_.has(value , "url")){
          value['path'] = value['url'];
        }

       // value.url = value.url.replace( "https://deepvisioninv.s3.eu-west-1.amazonaws.com/", "");
        // let postdata = { keyName: value.path , "taskId": this.taskDetails['_id']};
        let postdata = { keyName: value.url };
        if(sdkBucket){
          postdata['sdkBucket']  = true;
        }
  
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          
          window.open(response.data.result.data, "_blank");
         // window.location.href = response.data.result.data;
        });
      },

       findmsDoctype(ext=''){
        let docTypes =[
          'doc' ,"docx","txt","odt","rtf","dotm","wps","xml",
          "xl","xlsx","xla","xlsb"
        ]
        let imagTypes = ['jpeg','jpg' ,'png'];
        let pdfTypes =['pdf']
        if( _.findIndex(docTypes ,(vl)=>{ return vl==ext} ) !=-1){
          return "office";
        }else if( _.findIndex(imagTypes ,(vl)=>{ return vl==ext} ) !=-1){
          return "image";

        }else if( _.findIndex(pdfTypes ,(vl)=>{ return vl==ext} ) !=-1){
          
          return "pdf";
        
        }else {
          return false;
        }

      },
      onEnter() {
      this.getSdkList();
      this.userAggrementList()
    },

//////////////////////////userAggrementList
    userAggrementList(){
        /*
        agPage: 1,
     agPerPage: 25,
    agTotalpages: 0,
    agList:[],
        */
       const postData = {
        filters: {"title":this.serch_title ,
        "sdkIds": [],
    	"userIds": [],
    	"companyIds": [],
		"createdOnRange": []
        },
        sorting: this.sortKey, //{"path": "name","order": -1	},
        
        page: this.agPage,
        perpage: this.agPerPage,
      };

    if(_.has(this.selected_createdDateRange ,'startDate' ) && this.selected_createdDateRange.startDate != null && this.selected_createdDateRange.endDate != null && _.has(this.selected_createdDateRange ,'endDate' )){
    postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['startDate']).format("YYYY-MM-DD"));
    postData.filters['createdOnRange'].push(moment(this.selected_createdDateRange['endDate']).format("YYYY-MM-DD"));
    }

    if ( this.$route.params.id != undefined && this.$route.params.id != null ) {
         postData.filters['userIds'].push(this.$route.params.id);
    }
      
      
      if(!this.callFromSort){
            this.agList = [];
      }
      this.callFromSort = false;
     
       this.$vs.loading()
      this.$store
        .dispatch("getAgreementHistory", postData)
        .then((response) => {
          this.agList = response.list;
         
          this.agTotalpages = Math.ceil(response.totalCount / this.perPage);
           this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.loading.close();
          
        });

    },
     userAggrementListSortMe(sort_key = "" ,) {
      this.sortKey = { path: "createdOn", order: -1 };
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.sortKey = {};

        this.sortKey["path"] = sort_key;
        this.sortKey["order"] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        this.callFromSort =true;
        this.userAggrementList();
      }
    },
    getVersions(){
      let postData = {
      "filters":{ "title": ""},		
        "page": 1,
        "perpage": 1000000000
      }
      this.$store
        .dispatch("getSdkVersionsList", postData)
        .then((response) => {
          this.versions = response.list;
          
         
        })
        .catch((err) => {
          console.log(err);
          
          
        });
    },
  },
  mounted(){
    this.sortKey = { path: "createdOn", order: -1 };
   // sortKeys {  "name":'1',createdOn:-1,createdByName:1,updatedOn:1,version:1  },
    document.cookie = "accessToken="+this.activeUserInfo['accessToken'];
    this.getSdkList();
    this.apiURL = axios.defaults.baseURL;
     this.$store.dispatch("getCompanies").then((response) => {
      this.companies = response;
    });
    this.$store.dispatch("getSdkUsers").then((response) => {
      this.sdkUsers = response;
    });
    this.getsdkBucketList();
    this.getCustomerList();
    this.userAggrementList();
     this.getVersions();

  },
  watch:{
    popupcreateticket:(val)=>{
        let el = document.body;
        if (val) {
            el.classList.add('body-hidden');
        } else {
            el.classList.remove('body-hidden');
        }
        
    }

  },
}
</script>
<style  lang="scss">
.con-expand-users {
  .con-btns-user {
    display: flex;
    padding: 10px;
    padding-bottom: 0px;
    align-items: center;
    justify-content: space-between;
    .con-userx {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .list-icon {
        i {
          font-size: 0.9rem !important;
        }
      }
    }
  }
}
</style>